/**
 * @generated SignedSource<<1621b3653b0c3b6625307da8a58a5d20>>
 * @relayHash c21186b602c639ace15c259b6ab0118f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dbbb92b7baf48abf179aeb395a0d185c2db3c27a6b19a72a9264990c3303cfad

import type { ConcreteRequest } from 'relay-runtime';
export type useHydratedTeamAllFieldTypesActionQuery$variables = {
  id: string;
  siteId: string;
};
export type useHydratedTeamAllFieldTypesActionQuery$data = {
  readonly team: {
    readonly teamV2: {
      readonly displayName: string | null;
      readonly id: string;
    } | null;
  } | null;
};
export type useHydratedTeamAllFieldTypesActionQuery = {
  response: useHydratedTeamAllFieldTypesActionQuery$data;
  variables: useHydratedTeamAllFieldTypesActionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteId"
  }
],
v1 = [
  {
    "concreteType": "TeamQuery",
    "kind": "LinkedField",
    "name": "team",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "siteId"
          }
        ],
        "concreteType": "TeamV2",
        "kind": "LinkedField",
        "name": "teamV2",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "displayName"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useHydratedTeamAllFieldTypesActionQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHydratedTeamAllFieldTypesActionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "dbbb92b7baf48abf179aeb395a0d185c2db3c27a6b19a72a9264990c3303cfad",
    "metadata": {},
    "name": "useHydratedTeamAllFieldTypesActionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c8a6bed4928f92e22f9055edf70fd356";

export default node;
